var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data",style:({ width: _vm.width, height: _vm.height })},[_c('div',{staticClass:"content_box",style:({ top: _vm.top })},[_c('div',{staticClass:"img_box"},[_c('img',{staticClass:"full_img",attrs:{"src":_vm.sceneType === 'night' ? _vm.nightImg : _vm.dayImg,"alt":""}})]),_c('span',[_vm._v(_vm._s(_vm.$t('暂无数据')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }